import { render } from "./app-header-setting.vue?vue&type=template&id=1a2138f9&scoped=true&lang=true"
import script from "./app-header-setting.vue?vue&type=script&lang=js"
export * from "./app-header-setting.vue?vue&type=script&lang=js"

import "./app-header-setting.vue?vue&type=style&index=0&id=1a2138f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2138f9"]])

export default __exports__